var Event = require("cocos/framework/components/event");

var EmailDetailGiftItem = xClass("EmailDetailGiftItem", Event, function () {
    return cc.CSLoader.createNode("cocos/mail_gift_item.csb");
})

EmailDetailGiftItem.prototype.ctor = function () {
    let self = this;
    self.initUI();
}

EmailDetailGiftItem.prototype.initUI = function () {
    let self = this;
    self.mask = self.getChildByName("mask");
    self.icon = self.getChildByName("icon");
    self.num = self.getChildByName("num");
    self.common_hook = self.getChildByName("common_hook");
}

EmailDetailGiftItem.prototype.initData = function (data, acceptFlag) {
    let self = this;
    self.icon.removeAllChildren();
    const item = UIItemBuilder.createProp(data.itemId)[0];
    self.icon.addChild(item);
    self.num.setString("x" + data.num);
    self.mask.setVisible(acceptFlag);
    self.common_hook.setVisible(acceptFlag);
}

module.exports = EmailDetailGiftItem;
